import PropTypes from "prop-types";
import { ITXImage } from "components/ITXImage";
import { ITXVideo } from "components/ITXVideo";

/**
 * ITXMedia component
 * @param id
 * @param name
 * @param width
 * @param height
 * @param className
 * @param style
 * @param alt
 * @param layout
 * @param priority
 * @param loading
 * @param url
 * @param source
 * @param sourceWeb
 * @param source2K
 * @param source4K
 * @param videoMode
 * @param caption
 * @param loop
 * @param autoPlay
 * @param muted
 * @param allowPlayPause
 * @param allowFullscreen
 * @param actionAnimation
 * @param hideActionBar
 * @param containerClassName
 * @param locale
 * @param buttons
 * @param autoHideTime
 * @param type
 * @returns {JSX.Element}
 * @constructor
 */
export const ITXMedia = ({
  id,
  name,
  width,
  height,
  className = "",
  style = {},
  alt = "",
  layout = "",
  priority = false,
  loading = "lazy",
  url = "",
  source,
  sourceWeb,
  source2K,
  source4K,
  videoMode,
  caption,
  loop,
  autoPlay,
  muted,
  allowPlayPause,
  allowFullscreen,
  actionAnimation,
  hideActionBar,
  containerClassName,
  locale,
  buttons,
  autoHideTime,
  type,
}) => {
  if (type === "Image")
    return (
      <ITXImage
        id={id}
        url={url}
        style={style}
        className={className}
        name={name}
        width={width}
        height={height}
        alt={alt}
        loading={loading}
      />
    );

  if (type === "Video")
    return (
      <ITXVideo
        source={source}
        sourceWeb={sourceWeb}
        source2K={source2K}
        source4K={source4K}
        caption={caption}
        loop={loop}
        autoPlay={autoPlay}
        muted={muted}
        containerClassName={containerClassName}
        actionAnimation={actionAnimation}
        className={className}
        allowPlayPause={allowPlayPause}
        allowFullscreen={allowFullscreen}
        locale={locale}
        buttons={buttons}
        autoHideTime={autoHideTime}
        videoMode={videoMode}
      />
    );

  return <></>;
};

ITXMedia.prototype = {
  id: PropTypes.string,
  name: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
  loading: PropTypes.string,
  type: PropTypes.string,
  source: PropTypes.string,
  sourceWeb: PropTypes.string,
  source2K: PropTypes.string,
  source4K: PropTypes.string,
  caption: PropTypes.string,
  loop: PropTypes.bool,
  autoPlay: PropTypes.bool,
  muted: PropTypes.bool,
  containerClassName: PropTypes.string,
  actionAnimation: PropTypes.bool,
  hideActionBar: PropTypes.bool,
  videoMode: PropTypes.string,
  locale: PropTypes.string,
  buttons: PropTypes.array,
  autoHideTime: PropTypes.number,
  allowPlayPause: PropTypes.bool,
  allowFullscreen: PropTypes.bool,
};
